// The middleware origin, baked in at build time. CI passes the same value explicitly
// (`API_BASE_URL` in .gitlab-ci.yml); a checkout with no `.env` gets it from here rather than
// falling back to the console's own origin, where the dev server answers /api/* with index.html.
// Set VITE_API_BASE_URL to work against another middleware, or to empty for same origin.
const PRODUCTION_MIDDLEWARE = 'https://mapi.hispin.com';

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? PRODUCTION_MIDDLEWARE).replace(/\/+$/, '');

export const LIMITED_LINK_KEY_HEADER = 'x-limited-link-key';

// Behind Cloudflare Access a same-origin proxy adds the agent key server side, so the browser
// never holds one. Off unless the build sets VITE_AGENT_AUTH=proxy.
export const PROXY_AUTH = import.meta.env.VITE_AGENT_AUTH === 'proxy';

export const ACCESS_LOGOUT_PATH = '/cdn-cgi/access/logout';
